import React, { useEffect, useRef, useState } from "react";
import { motion } from 'framer-motion';
import { Fade } from "react-awesome-reveal";
import { MdChevronRight } from "react-icons/md";

import "../../styling.css";
import BackgroundCover from "../../../components/backgroundCover/BackgroundCover";
import TitleWithDescription from "../../../components/TitleWithDescription/TitleWithDescription";
import { debounce, modifyStyles, resetDefaultStyles } from "../../../utils/utilFunctions";
import { isMobile } from "../../../utils/appUtils";
import { COMPONENT_COLORS } from '../../../utils/componentColors';
import Title from "../../../components/Title/Title";
import Collection from "../../../components/Collection/Collection";
import { useLanguage } from "../../../context/LanguageContext";
import { fluoringTemplateTranslations } from "../../../translations/fluoringTemplate";

function FluoringCollection() {
    const { language } = useLanguage();
    const t = fluoringTemplateTranslations[language];

    const renderContent = () => {
        return (
            <>
                {/* Fluorescent Initials */}
                <div className="py-4 md:py-8">
                    <TitleWithDescription
                        title={{
                            firstLine: t.fluorTitle,
                            secondLine: t.fluorSubtitle
                        }}
                        description={t.fluorDescription}
                        layout="row"
                        className="px-4 md:px-8 lg:px-24"
                    />
                </div>

                {/* Video Section */}
                <div className="w-full relative aspect-video">
                    <video
                        className="w-full h-full object-cover"
                        autoPlay
                        loop
                        muted
                        playsInline
                    >
                        <source src="/video/fluoring.mp4" type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>

                {/* Message from Inside */}
                <TitleWithDescription
                    title={{
                        firstLine: t.messageTitle,
                        secondLine: t.messageSubtitle
                    }}
                    description={t.messageDescription}
                    layout="column"
                    image={{
                        src: "/images/jewellery_fluoring_grid_3_maxi.png",
                        alt: "Fluoring jewelry piece",
                        position: "left",
                        className: "w-full md:w-auto md:max-w-[90%] h-auto"
                    }}
                    className="bg-gradient-to-b from-[#C4C2C3] via-[#C8C6C7] via-[#CECCCD] to-[#D1CFD0] px-4 md:px-8 lg:px-24"
                />

                {/* The Collection intro */}
                <TitleWithDescription
                    title={{
                        firstLine: t.eternityTitle,
                        secondLine: t.eternitySubtitle
                    }}
                    description={t.eternityDescription}
                    layout="row"
                    className="px-4 md:px-8 lg:px-24"
                />

                {/* The Collection */}
                <div className="pb-8 md:pb-16">
                    <Collection
                        items={t.collectionItems}
                        clickable={false}
                    />
                </div>
            </>
        );
    };

    return (
        <div className="min-h-screen bg-white">
            <BackgroundCover
                backgroundHeight={isMobile() ? 400 : undefined}
                imagePosition="center"
                backgroundImage="/images/jewellery_fluoring_background.jpg"
                isWatchPage={true}
            >
                <div className="absolute top-1/2 left-[100px] -translate-y-[200px] z-10 hidden md:block">
                    <Title
                        firstLine={t.mainTitle}
                        secondLine={t.mainSubtitle}
                        className="text-white mt-[400px]"
                        animate={true}
                    />
                </div>
            </BackgroundCover>
            <div className="w-full">
                {renderContent()}
            </div>
        </div>
    );
}

export default FluoringCollection;

// Static content
const collectionItems = [
    {
        id: "1",
        name: "ETERNITY RING 8MM",
        description: "2.27 ct",
        image: "/images/jewellery_fluoring_grid_1_mini.png"
    },
    {
        id: "2",
        name: "ETERNITY RING 9.5MM",
        description: "3.28 ct",
        image: "/images/jewellery_fluoring_grid_2_medi.png"
    },
    {
        id: "3",
        name: "ETERNITY RING 10MM",
        description: "3.84 ct",
        image: "/images/jewellery_fluoring_grid_3_maxi.png"
    }
];